import React from 'react'

import './styles.scss'

type Props = {
  children: React.ReactNode
  as?: 'span' | 'p' | 'h3'
  className?: string
}

const ContentBlockTitle: React.FC<Props> = ({ children, as: Tag = 'span', className }) => {
  const classNames = ['content-block-title', className].filter(Boolean).join(' ')
  return <Tag className={classNames}>{children}</Tag>
}

export default ContentBlockTitle
